export default __webpack_public_path__ + "images/bin.v-b97e20a0e41f310db65a0adb9dd47903.svg";